// "recent" qualifies the count as loaded-page-only, not a full-channel total, until the server
// aggregate (DEV-5447's `GET entity-references`) replaces this client-side tally.
export const getReferenceBadgeTooltip = count =>
  count === 1
    ? 'Referenced in 1 recent chat message'
    : `Referenced in ${count} recent chat messages`;

export const getReferenceBadgeAriaLabel = count =>
  `${getReferenceBadgeTooltip(count)} — click to view`;
